import { render, staticRenderFns } from "./bxf_report.vue?vue&type=template&id=494dd1fd&scoped=true"
import script from "./bxf_report.vue?vue&type=script&lang=js"
export * from "./bxf_report.vue?vue&type=script&lang=js"
import style0 from "./bxf_report.vue?vue&type=style&index=0&id=494dd1fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494dd1fd",
  null
  
)

export default component.exports